exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-layout-for-china-map-wrap{width:100%;height:100%;position:relative}.card-layout-for-china-map-wrap .main{width:470px;height:200px;position:relative;left:120px;top:50px}.card-layout-for-china-map-wrap .left-top{position:absolute;top:10px;left:12px}.card-layout-for-china-map-wrap .right-top{position:absolute;top:-7px;right:23px}.card-layout-for-china-map-wrap .left-bottom{position:absolute;bottom:10px;left:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-372d2468!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/china-map-layout/index.vue
// module id = 167
// module chunks = 0